import React, { useState, useEffect } from 'react';
import { Spin, Empty, Pagination, Input } from 'antd';
import { SearchOutlined, ReadOutlined } from '@ant-design/icons';
import { getPublishedBlogPosts } from '../api/blogPostApi';
import BlogCard from '../components/BlogCard';

const BlogListPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [search, setSearch] = useState('');

  const pageSize = 9;

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const response = await getPublishedBlogPosts({ page, limit: pageSize, search });
        if (response?.success) {
          setPosts(response.blogPosts || []);
          setTotalPages(response.totalPages || 1);
          setTotal(response.total || 0);
        }
      } catch (error) {
        console.error('Error fetching blog posts:', error);
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [page, search]);

  const handleSearch = (value) => {
    setPage(1);
    setSearch(value.trim());
  };

  return (
    <div className="bloglist-page" style={{ fontFamily: "'Rubik', sans-serif", backgroundColor: '#fafbfc', minHeight: '100vh', padding: '50px 20px 80px' }}>
      <style>{`
        .bloglist-cards-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
        }
        @media (max-width: 992px) {
          .bloglist-cards-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 640px) {
          .bloglist-cards-grid { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 768px) {
          .bloglist-page {
            padding: 30px 16px 50px !important;
          }
          .bloglist-title {
            font-size: 30px !important;
          }
          .bloglist-subtitle {
            font-size: 15px !important;
          }
          .bloglist-badge {
            font-size: 11px !important;
            padding: 6px 14px !important;
          }
        }
      `}</style>

      <div style={{ maxWidth: 1300, margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <span className="bloglist-badge" style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '13px',
            fontWeight: 700,
            color: '#470172',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            background: '#f3e8ff',
            padding: '8px 18px',
            borderRadius: '50px',
            marginBottom: '20px'
          }}>
            <ReadOutlined /> Insights & Updates
          </span>
          <h1 className="bloglist-title" style={{ margin: 0, marginBottom: 12, color: '#000', fontSize: 46, fontWeight: 600, letterSpacing: '-0.5px' }}>
            Our Blogs
          </h1>
          <p className="bloglist-subtitle" style={{ fontSize: 18, color: '#666', maxWidth: 750, margin: '0 auto 8px', lineHeight: 1.7 }}>
            Insights, updates, and stories from the Association for Industrial Development — covering industrial growth,
            policy advocacy, skill development, and the people and initiatives shaping Vidarbha's future.
          </p>
          {/* {!loading && (
            <p style={{ fontSize: 14, color: '#999', fontWeight: 500, margin: '0 0 28px' }}>
              {total} {total === 1 ? 'article' : 'articles'} published
            </p>
          )} */}

          {/* <div style={{ maxWidth: 480, margin: '0 auto' }}>
            <Input
              size="large"
              placeholder="Search articles..."
              prefix={<SearchOutlined style={{ color: '#470172' }} />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onPressEnter={(e) => handleSearch(e.target.value)}
              allowClear
              onClear={() => handleSearch('')}
              style={{ borderRadius: 50, fontFamily: "'Rubik', sans-serif" }}
            />
          </div> */}
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '80px 0' }}>
            <Spin size="large" />
            <p style={{ marginTop: 24, color: '#666' }}>Loading blog posts...</p>
          </div>
        ) : posts.length === 0 ? (
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #eee', padding: '60px 20px' }}>
            <Empty
              description={
                <span style={{ fontSize: 18, fontWeight: 600, color: '#470172' }}>
                  {search
                    ? `No articles found matching "${search}".`
                    : 'No blog posts published yet. Check back soon!'}
                </span>
              }
            />
          </div>
        ) : (
          <>
            <div className="bloglist-cards-grid" style={{ marginBottom: 48 }}>
              {posts.map((post) => (
                <BlogCard key={post._id} post={post} />
              ))}
            </div>

            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Pagination
                  current={page}
                  total={totalPages * pageSize}
                  pageSize={pageSize}
                  onChange={(p) => setPage(p)}
                  showSizeChanger={false}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BlogListPage;
